import ko from 'knockout';
import _ from 'underscore';
import {
  formatCost,
  formatDecimal,
  formatPercentHundredths,
  getIncreaseSymbol,
  NOT_AVAILABLE_DEFAULT_STR,
} from '@bingads-webui-campaign/recommendation-core';
import increaseArrowTemplate from '../template/increaseArrow.pug';

function noChange(from, to, type, i18n) {
  if (type === 'ctr') {
    return formatPercentHundredths(from, i18n) === formatPercentHundredths(to, i18n);
  } else if (type === 'spend') {
    return formatCost(from, i18n, i18n.currency) === formatCost(to, i18n, i18n.currency);
  }

  return formatDecimal(from, i18n) === formatDecimal(to, i18n);
}
export default class ViewModel {
  constructor({
    extensionData,
    i18n,
    readOnly,
  }) {
    this.i18n = i18n;
    this.isApplyEnable = ko.observable();
    this.isCPCIncrease = ko.observable();
    this.readOnly = readOnly;

    const optId = extensionData.ids;
    const opt = extensionData.idOpportunityMap[optId];
    this.delta = {
      clicks: opt.EstimatedKPI.ClickDelta,
      ctr: opt.EstimatedKPI.CTRDelta,
      spend: opt.EstimatedKPI.CostDelta,
      cpc: formatDecimal(opt.EstimatedKPI.CPCNew, i18n) - formatDecimal(opt.EstimatedKPI.CPC, i18n),
    };

    this.oldValue = {
      clicks: opt.EstimatedKPI.Clicks,
      ctr: opt.EstimatedKPI.CTR,
      spend: opt.EstimatedKPI.Cost,
      cpc: opt.EstimatedKPI.CPC,
    };

    this.newValue = {
      clicks: opt.EstimatedKPI.ClicksNew,
      ctr: opt.EstimatedKPI.CTRNew,
      spend: opt.EstimatedKPI.CostNew,
      cpc: opt.EstimatedKPI.CPCNew,
    };

    this.CtrChangePrecentage = opt.EstimatedKPI.CtrLift;
    this.formatedRange = {};
    this.formatedDelta = {};
    this.estImpactType = {};

    const clicks = 'clicks';
    const ctr = 'ctr';
    const spend = 'spend';
    const cpc = 'cpc';
    const positiveImpact = 'positive';
    const negativeImpact = 'negative';

    _.each([clicks, ctr, spend, cpc], (type) => {
      const delta = type === ctr ? this.CtrChangePrecentage : this.delta[type];

      if (type === ctr) {
        const increaseSymbol = getIncreaseSymbol(this.delta[type]);
        this.formatedRange[type] = this.i18n.getString('SiteLink_Inline_View_Range_CTR', {
          from: formatPercentHundredths(this.oldValue[type], this.i18n),
          to: formatPercentHundredths(this.newValue[type], this.i18n),
          delta: increaseSymbol + formatPercentHundredths(this.delta[type], this.i18n),
        });
      } else if (type === spend) {
        this.formatedRange[type] = this.i18n.getString('SiteLink_Inline_View_Range', {
          from: formatCost(this.oldValue[type], this.i18n, this.i18n.currency),
          to: formatCost(this.newValue[type], this.i18n, this.i18n.currency),
        });
      } else {
        this.formatedRange[type] = this.i18n.getString('SiteLink_Inline_View_Range', {
          from: formatDecimal(this.oldValue[type], this.i18n),
          to: formatDecimal(this.newValue[type], this.i18n),
        });
      }

      if (noChange(this.oldValue[type], this.newValue[type], type, this.i18n)) {
        this.estImpactType[type] = negativeImpact;
        this.formatedDelta[type] = NOT_AVAILABLE_DEFAULT_STR;
      } else if (type === cpc) {
        this.isCPCIncrease(delta > 0);
        this.estImpactType[type] = delta > 0 ? negativeImpact : positiveImpact;
        this.formatedDelta[type] = getIncreaseSymbol(delta) + formatDecimal(delta, this.i18n);
      } else if (type === spend) {
        this.estImpactType[type] = delta > 0 ? negativeImpact : positiveImpact;
        this.formatedDelta[type] = getIncreaseSymbol(delta) + formatCost(delta, this.i18n, this.i18n.currency); //eslint-disable-line
      } else if (type === ctr) {
        this.estImpactType[type] = delta > 0 ? positiveImpact : negativeImpact;
        this.formatedDelta[type] = increaseArrowTemplate({
          symbol: getIncreaseSymbol(delta, 'arrow'),
          text: formatPercentHundredths(delta, this.i18n),
        });
      } else if (type === clicks) {
        this.estImpactType[type] = delta > 0 ? positiveImpact : negativeImpact;
        this.formatedDelta[type] = getIncreaseSymbol(delta) + formatDecimal(delta, this.i18n);
      }
    });
  }
}
